import { VFAComputedMetrics, VFAFlatMetrics } from "types/tests/specifics";

/**
 * Collapses the nested `computedMetrics` contract into the flat lookup the
 * result views read from. Returns null when the backend could not compute the
 * metrics, so callers have to handle that case explicitly instead of silently
 * reading undefined off a nested object.
 */
export function flattenComputedMetrics(
  computedMetrics: VFAComputedMetrics | null | undefined,
): VFAFlatMetrics | null {
  if (!computedMetrics) return null;
  return { ...computedMetrics.metrics, ...computedMetrics.maps };
}
